import { Brand, Button, LinkButton } from '../../ui';
import { lockedMessage, type LockedGate } from '../../lib/entitlement';
import { COURSE_HREF } from '../../lib/landing';
import { useStrings } from '../../state/useLocale';
import type { PublicMission } from '../../types';

/** Keep the requested practice route visible and explain the action that opens it. */
export function WorkspaceGate({ mission, missions, gate, signedIn, busy, onSignIn, onUnlock }: {
  mission: PublicMission | undefined; missions: PublicMission[]; gate: LockedGate | null;
  signedIn: boolean; busy: boolean; onSignIn(): void; onUnlock(): void;
}) {
  const s = useStrings();
  return <div className="workspace-gate">
    <header><Brand /></header>
    <main>
      <h1>{s.progress.sandbox.blockedTitle}</h1>
      {mission && <p>{mission.title}</p>}
      <p role="status">{mission && gate
        ? lockedMessage(gate, mission, missions, signedIn)
        : s.app.toast.noSuchLevel}</p>
      <p>{s.progress.sandbox.accessNote}</p>
      <div className="workspace-gate-actions">
        {gate?.kind === 'signin' && <Button variant="solid" disabled={busy} onClick={onSignIn}>
          {busy ? s.home.standing.signingIn : s.home.standing.signIn}
        </Button>}
        {gate?.kind === 'paywall' && <Button variant="solid" onClick={onUnlock}>{s.reading.debrief.getCourse}</Button>}
        <LinkButton href={COURSE_HREF} variant="quiet">{s.progress.sandbox.levelList}</LinkButton>
      </div>
    </main>
  </div>;
}
